import * as yup from 'yup';

import {
  type ConfigurationFormData,
  configurationDefaultValues,
  configurationSchema,
} from './configurationSchema';
import {
  type ContentFormData,
  contentDefaultValues,
  contentSchema,
} from './contentSchema';
import {
  type CreationFormData,
  creationDefaultValues,
  creationSchema,
} from './creationSchema';
import {
  type ScheduleFormData,
  scheduleDefaultValues,
  scheduleSchema,
} from './scheduleSchema';

export const marketplaceRootValidationSchema = yup.object({
  creation: creationSchema,
  configuration: configurationSchema,
  content: contentSchema,
  schedule: scheduleSchema,
});

export type MarketplaceRootData = yup.InferType<
  typeof marketplaceRootValidationSchema
>;

export const marketplaceStepFields = [
  'creation',
  'configuration',
  'content',
  'schedule',
] as const satisfies ReadonlyArray<keyof MarketplaceRootData>;

export const marketplaceRootDefaultValues: MarketplaceRootData = {
  creation: creationDefaultValues,
  configuration: configurationDefaultValues,
  content: contentDefaultValues,
  schedule: scheduleDefaultValues,
};

export {
  creationSchema,
  configurationSchema,
  contentSchema,
  scheduleSchema,
  type CreationFormData,
  type ConfigurationFormData,
  type ContentFormData,
  type ScheduleFormData,
};
